<template>
  <div class="vm-videochat-content vm-videochat-content-invite">
    <div class="vm-videochat-header">
      <div class="vm-videochat-header-wrapper">
        <button class="vm-text-button" @click="$emit('close')">
          <i class="material-icons">arrow_back_ios</i>
          <span>OK</span>
        </button>  
        <div class="vm-videochat-info">
          <div class="vm-videochat-title">Результат оповещения</div>
        </div>
      </div>
    </div>
    <div class="vm-videochat-invite-list">
      <Item v-for="user in users" :key="user.uuid" v-bind="user" />
    </div>
  </div>
</template>

<script>
import Item from '../invite/item';

export default {
  props: {
    users: Array
  },
  components: { Item }
};
</script>

<style scoped>
.vm-selected-users {
  display: flex;
  align-items: center;
}
.vm-selected-users .vm-selected-user {
  display: flex;
  background-color: #5C48D4;
  color: #fff;
  width: 80px;
  flex: 0 0 80px;
  border-radius: 4px;
  margin-right: 6px;
  align-items: center;
  height: 28px;
  padding: 0 4px;
}
.vm-selected-users .vm-selected-user:last-child {
  margin-right: 0;
}
.vm-selected-user-label {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  
}
.vm-selected-users button {
  background-color: transparent;
  color: #fff;
  display: flex;
  justify-content: center;
}
.vm-selected-users button i {
  font-size: 20px;
}
.vm-videochat-search-wrap {
  display: flex;
  padding: 12px 0 12px 12px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.07);
  border-radius: 4px;
}
.vm-videochat-header {
  height: 60px;
  flex: 0 0 60px;
  border-radius: 0 4px 0 0;
  padding: 0 24px;
}
.vm-videochat-header-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.vm-text-button {
  color: #424242;
  display: flex;
  align-items: center;
  background-color: transparent;
  outline: 0;
  font-weight: 600;
  color: #5c48d4;
}
.vm-text-button:disabled {
  color: #8a8a8a;
}
.vm-action-buttons {
  margin-left: auto;
}
.vm-invite-button {
  color: #424242;
}
.vm-invite-button:disabled {
  opacity: 0.5;
}
.vm-videochat-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(to right, rgb(242, 232, 251), rgb(234, 239, 250));
}
.vm-videochat-content-invite .vm-videochat-info {
  margin-left: 24px;
}
.vm-videochat-content-invite .vm-videochat-subheader {
  padding: 0 24px;
}
.vm-videochat-content-invite .vm-videochat-subheader .vm-videochat-search-wrap {
  padding: 0 4px;
  margin: 12px 0;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
}
.vm-videochat-content-invite .vm-videochat-subheader .vm-videochat-search {
  color: #686868;
  background-color: transparent;
}
.vm-videochat-content-invite .vm-videochat-subheader .vm-videochat-search::placeholder {
  color: #686868;
}
.vm-videochat-content-invite .vm-videochat-invite-list {
  overflow: auto;
  flex: auto;
}
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>